import {
  Activity,
  AlertTriangle,
  Ban,
  Building2,
  Camera,
  CreditCard,
  FileText,
  Hourglass,
  LayoutDashboard,
  MessageCircle,
  PhoneCall,
  Bot,
  ScrollText,
  Settings,
  ShieldCheck,
  Tags,
  Users,
  Zap,
  type LucideIcon,
} from 'lucide-react';

export interface SuperAdminNavItem {
  label: string;
  /** Present only once the page exists; other items render as "Soon". */
  path?: string;
  icon: LucideIcon;
  /** Delivery subphase of the Super Admin panel (docs/PROGRESS.md). */
  phase: string;
}

export interface SuperAdminNavSection {
  title: string | null;
  items: SuperAdminNavItem[];
}

export const SUPER_ADMIN_NAV: SuperAdminNavSection[] = [
  {
    title: null,
    items: [{ label: 'Overview', path: '/super-admin', icon: LayoutDashboard, phase: '7d-2' }],
  },
  {
    title: 'Merchants',
    items: [
      { label: 'All merchants', icon: Building2, phase: '7d-3' },
      { label: 'Trials', icon: Hourglass, phase: '7d-3' },
      { label: 'Suspended', icon: Ban, phase: '7d-3' },
    ],
  },
  {
    title: 'Revenue',
    items: [
      { label: 'Subscriptions', icon: CreditCard, phase: '7d-4' },
      { label: 'Payments', icon: CreditCard, phase: '7d-4' },
      { label: 'GST invoices', icon: FileText, phase: '7d-4' },
      { label: 'Plans & pricing', icon: Tags, phase: '7d-4' },
    ],
  },
  {
    title: 'Usage',
    items: [
      { label: 'WhatsApp', icon: MessageCircle, phase: '7d-5' },
      { label: 'Instagram', icon: Camera, phase: '7d-5' },
      { label: 'Automations', icon: Zap, phase: '7d-5' },
      { label: 'AI assistant', icon: Bot, phase: '7d-5' },
      { label: 'AI calling', icon: PhoneCall, phase: '7d-5' },
    ],
  },
  {
    title: 'Operations',
    items: [
      { label: 'System health', icon: Activity, phase: '7d-5' },
      { label: 'Failed jobs', icon: AlertTriangle, phase: '7d-5' },
      { label: 'Audit logs', icon: ScrollText, phase: '7d-6' },
    ],
  },
  {
    title: 'Settings',
    items: [
      { label: 'Platform settings', icon: Settings, phase: '7d-6' },
      { label: 'Super admins', icon: Users, phase: '7d-6' },
    ],
  },
];

export const SUPER_ADMIN_ICON = ShieldCheck;
